module.exports = __webpack_public_path__ + "static/Amy-833a8d93d77944ab31112d4a23075662.jpg";